import { makeObservable, observable, action } from 'mobx';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';
import { FreeBetWinningType } from '@pascal/pascal-core';
import { doBetStore } from './doBetStore';

class OddStore {
  oddData = {};

  currentBetAmount = {};

  currentWinAmount = {};

  freeBetMaxPayout = {};

  constructor() {
    makeObservable(this, {
      oddData: observable,
      currentBetAmount: observable.deep,
      freeBetMaxPayout: observable.deep,
      currentWinAmount: observable.deep,
      setOddData: action.bound,
      resetOddData: action.bound,
      setInitialOddData: action.bound,
      setCurrentBetAmount: action.bound,
      setInitialCurrentBetAmount: action.bound,
      setCurrentWinAmount: action.bound,
      handleCurrentWinAmount: action.bound,
      resetDemoCurrentBetAmount: action.bound,
      clearCurrentWinAmount: action.bound,
      setFinishWinAmount: action.bound,
      setCurrentFreeBetMaxPayout: action.bound,
    });
  }

  setCurrentFreeBetMaxPayout(gameTypeId, value, freeBetId, userFreebets) {
    this.freeBetMaxPayout[gameTypeId] =
      value === null
        ? value
        : userFreebets?.find((item) => item.id === freeBetId).maxPayout ||
          freeBetStore.activeFreeBet.maxPayout;
  }

  setInitialCurrentBetAmount(data) {
    this.currentBetAmount = data;
  }

  setCurrentBetAmount(value, gameTypeId) {
    this.currentBetAmount[gameTypeId] = value;
  }

  setCurrentWinAmount(value, gameTypeId) {
    this.currentWinAmount[gameTypeId] = value;
  }

  handleCurrentWinAmount(odd, gameTypeId) {
    const currentMaxWin = this.freeBetMaxPayout[gameTypeId] || gameConfigStore.limits.maxWin;

    const { freeBetType } = doBetStore.doBetSectionsData[gameTypeId];
    const currentBetAmount =
      freeBetType === FreeBetWinningType.Win
        ? odd * this.currentBetAmount[gameTypeId] - this.currentBetAmount[gameTypeId]
        : odd * this.currentBetAmount[gameTypeId];
    this.setCurrentWinAmount(
      currentBetAmount > currentMaxWin ? currentMaxWin : currentBetAmount,
      gameTypeId
    );
  }

  setFinishWinAmount(winAmount, gameTypeId) {
    this.currentWinAmount[gameTypeId] = winAmount;
  }

  clearCurrentWinAmount(gameTypeId) {
    this.currentWinAmount[gameTypeId] = null;
  }

  setInitialOddData(data) {
    this.oddData = data;
  }

  setOddData(odd, gameTypeId) {
    this.oddData[gameTypeId] = odd;
    if (this.currentBetAmount[gameTypeId]) {
      this.handleCurrentWinAmount(odd, gameTypeId);
    }
  }

  resetOddData() {
    this.oddData = {};
  }

  resetDemoCurrentBetAmount(allGameTypes) {
    allGameTypes.forEach((gameTypeId) => {
      this.setCurrentBetAmount(null, gameTypeId);
      this.clearCurrentWinAmount(gameTypeId);
    });
  }
}

export const oddStore = new OddStore();
